<template>
  <div class="container">
    <h1>HTTP 404 Not Found</h1>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'ページが見つかりませんでした'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue